import { MultiResultHelper } from '../../../helpers/multiresult.helper';
import { DataDescription } from '../../datadescription/multi/datadescription.model';
import { MultiResult } from '../../datadescription/multi/multiresult.model';
import { CellStyle } from '../../styling/cell.style';
import { StyleMerger } from '../../styling/styleMerger';
import { ITaskExecuter } from '../atask.model';

export class SumFormattingTaskExecuter implements ITaskExecuter {
    static TaskID = 'sumformattingtask';

    IsStyleAppliedToValues = true;

    Style: CellStyle;
    Result: MultiResult;
    DataDescription: DataDescription;
    Merger: StyleMerger;

    Init(settings: any, result: MultiResult, dataDescription: DataDescription, context: any) {
        this.Result = result;
        this.DataDescription = dataDescription;
        if (settings) {
            this.IsStyleAppliedToValues = settings.IsStyleAppliedToValues;
            if (settings.Style) {
                this.Style = settings.Style;
                delete this.Style['MergeID'];
            }
        }
        this.Merger = StyleMerger.GetStyleMerger(context);
    }

    Execute() {
        if (this.Style && this.Merger) {
            if (this.Result.YAxis.SumNode) {
                this.Result.YAxis.SumNode.StyleID = this.Merger.MergeStyle(this.Result.YAxis.SumNode.StyleID, this.Style);
                if (this.IsStyleAppliedToValues) {
                    MultiResultHelper.ExecuteOnAllNodes(this.Result.XAxis, (xNode) => {
                        this.Result.Measures.Nodes.forEach(mNode => {
                            const cell = MultiResultHelper.GetCellOrNew(this.Result, xNode, this.Result.YAxis.SumNode, mNode);
                            cell.StyleID = this.Merger.MergeStyle(cell.StyleID, this.Style);
                        });
                    }, true);
                }
            }
        }
    }
}
